var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"home"},[_c('div',{staticClass:"play-btn"},[_c('div',{class:['games-left', _vm.testPassed ? 'testPassed' : 'testFailed']},[_c('br'),_vm._v(" "),(_vm.testPassed)?_c('p',[_vm._v("Test"),_c('br'),_vm._v("has"),_c('br'),_vm._v("Passed :)")]):_c('p',[_vm._v("Test"),_c('br'),_vm._v("has NOT"),_c('br'),_vm._v("Passed :(")])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-144e4033","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stressTests/TestFullGameScenario.vue
// module id = null
// module chunks = 